var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_661",
    "data-name": "Group 661",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.262,
    height: 51.261,
    viewBox: "0 0 51.262 51.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M25.63,0A25.63,25.63,0,1,1,0,25.63,25.63,25.63,0,0,1,25.63,0Z",
    fill: "#0a2a46",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M22.436,7.248A2.88,2.88,0,0,0,20.41,5.209c-1.787-.482-8.953-.482-8.953-.482s-7.166,0-8.953.482A2.879,2.879,0,0,0,.479,7.248,30.19,30.19,0,0,0,0,12.8a30.185,30.185,0,0,0,.479,5.551A2.878,2.878,0,0,0,2.5,20.389c1.787.482,8.953.482,8.953.482s7.166,0,8.953-.482a2.879,2.879,0,0,0,2.026-2.039,30.19,30.19,0,0,0,.479-5.551,30.19,30.19,0,0,0-.479-5.551ZM9.114,16.207V9.392L15.1,12.8,9.114,16.207Z",
    transform: "translate(14.322 13.175)",
    fill: "#e4e4e4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.eedccaca6570e39143ec5aecb450d69d.svg";
export { ForwardRef as ReactComponent };